export default __webpack_public_path__ + "static/media/Agile.3a10fed6.svg";